export const pedQuestions =[
  {
    "DiseaseID": "13",
    "question_title": "Hypertension: High blood pressure history.",
    "question_desc": ""
  },
  {
    "DiseaseID": "14",
    "question_title": "Diabetes Mellitus: Sugar history.",
    "question_desc": ""
  },
  {
    "DiseaseID": "15",
    "question_title": "Hyperlipidemia: Cholesterol history.",
    "question_desc": ""
  },
  {
    "DiseaseID": "16",
    "question_title": "Tobacco/Alcohol Usage",
    "question_desc": "Does any person proposed to be insured smoke or consume tobacco in any form or alcohol? If yes, please indicate the quantity consumed. If not, please indicate No."
  },
  {
    "DiseaseID": "17",
    "question_title": "Heart and Circulatory Conditions or Disorders",
    "question_desc": "Chest pain, angina, palpitations, congestive heart failure, coronary artery disease, heart attack, bypass surgery, angioplasty, valve disorder/replacement, pacemaker insertion, rheumatic fever, congenital heart condition, varicose veins, clots in veins or arteries, blood disorders, anticoagulant therapy, etc."
  },
  {
    "DiseaseID": "18",
    "question_title": "Urinary Conditions or Disorders",
    "question_desc": "Blood in urine, increase in urinary frequency, painful or difficult urination, kidney and/or bladder infections, stones of urinary system, kidney failure, dialysis, or any other kidney or urinary tract or prostate disease."
  },
  {
    "DiseaseID": "19",
    "question_title": "Musculoskeletal Conditions or Disorders",
    "question_desc": "Joint or back pain, arthritis, spondylosis, spondylitis, spinal disorders, surgeries, osteoporosis, osteomyelitis, joint replacement, or any other disorder of muscle, bone, joint, ligaments, tendons, or discs, herniated disc fractures or accidents or implants amputation or prosthesis Muscle weakness Polio etc"
  },
  {
    "DiseaseID": "20",
    "question_title": "Respiratory Conditions or Disorders",
    "question_desc": "Shortness or difficulty of breath, tuberculosis, asthma, bronchitis, chronic obstructive pulmonary disease (COPD), chronic cough, coughing of blood, etc., or any other lung or respiratory disease."
  },
  {
    "DiseaseID": "21",
    "question_title": "Digestive Conditions or Disorders",
    "question_desc": "Jaundice, chronic diarrhea, intestinal bleeding or problems, polyps, diseases of the pancreas, liver or gall bladder, hepatitis A/B/C, ulcerative colitis, Crohn’s disease, inflammatory or irritable bowel disease, cirrhosis, unexplained weight loss or gain, eating disorder, or any other gastrointestinal condition."
  },
  {
    "DiseaseID": "22",
    "question_title": "Cancer or Tumor",
    "question_desc": "Benign or malignant tumor, any growth or cyst, any cancer diagnosed earlier and/or treatment taken for cancer."
  },
  {
    "DiseaseID": "23",
    "question_title": "Brain, Nervous System, Mental or Psychiatric Conditions",
    "question_desc": "Loss of consciousness, fainting, dizziness, numbness or tingling, weakness, paralysis, head injury, stroke, migraine headaches or chronic severe headaches, sleep apnea, multiple sclerosis, seizures or epilepsy, any other brain or nervous system disease, mental or psychiatric disorder, ADHD, autism, disability or deformity whether physical or mental, etc."
  },
  {
    "DiseaseID": "24",
    "question_title": "Female Reproductive Conditions or Disorders",
    "question_desc": "Pelvic pain, abnormal menstrual bleeding, abnormal PAP smear, endometriosis, fibroid, cyst or fibroadenoma, bleeding disorder, pelvic infection, or any other gynecological or breast cysts or lumps or tumor."
  },
  {
    "DiseaseID": "25",
    "question_title": "Eye, Ear, Nose and Throat Disorders",
    "question_desc": "Cataract, glaucoma, optic neuritis, retinal detachment, conjunctivitis, squint, ptosis, blindness, refractive error or spectacle number in dioptres, otitis media, deviated nasal septum, otosclerosis, loss of speech, hearing loss, nasal polyps, chronic sinusitis, or any other disorder of ear, nose and throat."
  },
  {
    "DiseaseID": "26",
    "question_title": "Sexually Transmitted Diseases",
    "question_desc": "HIV or AIDS, immunodeficiency, or any venereal disease (VD) or sexually transmitted disease (STD)."
  },
  {
    "DiseaseID": "27",
    "question_title": "Metabolic, Endocrine and Autoimmune/Genetic Disorders",
    "question_desc": "Adrenal or pituitary disorders, thyroid disorder, lupus, scleroderma, thalassemia, anemia, hemophilia, obesity and related surgeries, etc."
  },
  {
    "DiseaseID": "28",
    "question_title": "Pregnancy or Infertility",
    "question_desc": "Is any female member pregnant, tested positive with a home pregnancy test, or undergoing infertility treatment or ectopic pregnancy?"
  },
  {
    "DiseaseID": "29",
    "question_title": "Chronic or Long-Term Medical Conditions",
    "question_desc": "Does the person proposed to be insured suffer from any chronic or long-term medical condition or have any other disability, abnormality, recurrent illness or injury, or unable to perform normal activities?"
  },
  {
    "DiseaseID": "30",
    "question_title": "Other Consultations, Hospitalizations or Medications",
    "question_desc": "Has any member consulted or received treatment from any doctor or health care provider for any other condition or symptoms, undergone any hospitalization or surgery, or is currently taking medications or undergoing diagnostic procedures?"
  },
  {
    "DiseaseID": "31",
    "question_title": "Family History of Diseases",
    "question_desc": "Does the individual have a family history of any disease like heart disease, brain disease, cancer, organ failure, autoimmune or genetic disorder?"
  }
]
